import React, { useEffect, useState } from 'react';
import ReactSelect from 'react-select';
 import Input from '../Common/Input';
 import Select from '../Common/Select';
import { useMemo } from 'react';
import { useEntityCrud } from '../../hooks/useEntityCrud';


const Form = ({ formik, groupList, setGroupList, activeList, businessList, orgAddress, setOrgAddress, isEditMode }) => {

    const { readDataByFilter: readDataGroup } = useEntityCrud('Group/GetAllGroups')

    const businessAll = useMemo(() => businessList
        .map(item => ({ value: item.id, label: item.title ,  isActive:item.isActive})));
    const groupAll = useMemo(() => groupList
        .map(item => ({ value: item.id, label: item.title  ,  isActive:item.isActive})))

    useEffect(() => {
        const postedData = {
            buisnessId: orgAddress?.buisnessId?.value,
        };
        readDataGroup(postedData).then(res => {
            setGroupList(res.data.result)
        });
    }, [businessList, orgAddress?.buisnessId?.value])

    const handleChangeBusiness = (value) => {        
        setOrgAddress(prevState => ({ ...prevState, groupId: "" }))
        setOrgAddress(prevState => ({ ...prevState, buisnessId: value }))
    }

    const handleChangeGroup = (value) => {
        setOrgAddress(prevState => ({ ...prevState, groupId: value }))
    }


    return (
        <form onSubmit={formik.handleSubmit}>
            <div class="card">
                <div className="row">
                    {isEditMode === false && <div className="col-md-3">
                        <label>
                            کسب و کار
                        </label>
                        <ReactSelect label="   کسب و کار"
                            required
                            options={businessAll.filter(item => item.isActive===true)}
                            value={orgAddress?.buisnessId}
                            onChange={handleChangeBusiness}
                            placeholder="انتخاب کنید"
                            name="buisnessId"
                        />
                    </div>}
                    {isEditMode === false && <div className="col-md-3">
                        <label>
                            گروه
                        </label>
                        <ReactSelect label="      گروه"
                            required
                            options={groupAll.filter(item => item.isActive===true)}
                            placeholder="انتخاب کنید"
                            name="groupId"
                            value={orgAddress?.groupId}
                            onChange={handleChangeGroup}
                        />
                    </div>}
                    <div className="col-md-3">
                        <Input label=" عنوان سرویس" name="title" formik={formik} required={true} />
                    </div>
                    <div className="col-md-3">
                        <Select label="روش ارسال" name="deliverType" formik={formik}>
                            <option value="1">دریافت حضوری</option>
                            <option value="2">ارسال با پیک</option>
                            <option value="3">هر دو</option>
                        </Select>
                    </div>
                   {/*  {isEditMode === false && <div className="col-md-3" >
                        <div className="form-group mb-0">
                            <label >فعال؟</label>
                            <ReactSelect
                                required
                                placeholder="انتخاب کنید"
                                options={activeList}
                                name="activeId"
                                isSearchable={true}
                                value={formik.values.activeId}
                                isRtl={true}
                                onChange={value => formik.setFieldValue("activeId", value)}
                                noOptionsMessage={() => 'نام مورد نظر یافت نشد'}
                            />
                        </div>
                    </div>} */}
                </div>
            </div>
            <div className='mx-auto text-center my-4 py-4'>
                <button className="btn btn-success">ذخیره اطلاعات</button>
            </div>
        </form>
    );
}

export default Form;